const mapStateToProps = state => 
     ({
        currentUser: state.security.currentUser,
        datosCiudadanoTable: state.solicitudEmpadronamiento.datosCiudadanoTable,
        datosSolicitudRenap: state.solicitudEmpadronamiento.datosSolicitudRenap,
        datosIdentidad: state.solicitudEmpadronamiento.datosIdentidad,
        esRechazadoOEmpadronado: state.solicitudEmpadronamiento.esRechazadoOEmpadronado,
        idSolicitudGeneradoNacional: state.solicitudEmpadronamientoExtranjero.idSolicitudGeneradoNacional,
        tabValueInitial: state.solicitudEmpadronamiento.tabValueInitial,
        citaEnProceso: state.citaDeEmpadronamiento.citaEnProceso,
        citaEnProcesoVacia: state.citaDeEmpadronamiento.citaEnProcesoVacia,
        datosSolicitudGeneradoNancional: state.solicitudEmpadronamientoExtranjero.datosSolicitudGeneradoNancional,
        idSoliciutudDelegacionProcesado: state.solicitudEmpadronamientoExtranjero.idSoliciutudDelegacionProcesado,

        dialogoStatus: state.dialogoStatus.status,


        datosGeneralesDelCiudadano: state.solicitudEmpadronamientoExtranjero.datosGeneralesDelCiudadano,
        // steper solicitud portal web
        stepPortalWeb: state.solicitudEmpadronamientoPortalWeb.stepPortalWeb,

    });

export default mapStateToProps;
